import { render } from "./FamilyIncomeBenefitPlanSelection.vue?vue&type=template&id=23529844&scoped=true"
import script from "./FamilyIncomeBenefitPlanSelection.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitPlanSelection.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitPlanSelection.vue?vue&type=style&index=0&id=23529844&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23529844"]])

export default __exports__